import { render, staticRenderFns } from "./SkupDodatniSadrzajForma.vue?vue&type=template&id=1deadb51&scoped=true&"
import script from "./SkupDodatniSadrzajForma.vue?vue&type=script&lang=js&"
export * from "./SkupDodatniSadrzajForma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1deadb51",
  null
  
)

export default component.exports